import { useState } from 'react';

// import { routeTypes } from '../../../useSystemRoutes'
import { useUsers, userTypes } from '../../../api/useUsers'
import { useSystemPrompt } from '../../../useSystemPrompt';
import { useAuthAccess } from "../../../useAuthAccess";

import { documentTypes } from "../../../api/useDocuments"
import { validateRouteType } from './default';

import {
    useDependencies,
    targetTypes as dependencyTargetTypes,
    dependencyModules,
    dependencyRelations,
    dependencyRefs,
    formikDependencyStateField,
} from "../../../api/useDependencies"

export function useStateRetailCashSales() {

    const { getDependencyItem } = useDependencies()

    const { authData } = useAuthAccess();

    const { promptMessage } = useSystemPrompt()
    const { get } = useUsers({ userType: userTypes.member })

    // const validateRouteType = (val) => {
    //     if (
    //         val !== routeTypes.admin &&
    //         val !== routeTypes.retail
    //     ) throw new Error(`Unsupported route : ${val}`)
    // }

    const updateFormikState = async ({
        data,
        routeType,
        setFieldValue,
        appendInventoryBatch
    }) => {

        // validateRouteType(routeType);
        validateRouteType(routeType, documentTypes.retailCashSales)

        const {
            document,
            payment,
            items
        } = data

        // only load these fields
        setFieldValue(`remark`, document?.doc_remark ? document.doc_remark : "")

        setFieldValue(`paymentId`, payment?.payment_type)
        setFieldValue(`paymentName`, payment?.bank_name)
        setFieldValue(`paymentTypeId`, payment?.bank_account_no)
        setFieldValue(`paymentTypeName`, payment?.bank_account_name)
        setFieldValue(`paymentReference`, payment?.payment_reference ? payment.payment_reference : "")
        setFieldValue(`receiveAmount`, payment?.receive_amount ? payment.receive_amount : "")

        items.forEach((e, index) => {
            setFieldValue(`rows.${index}.itemId`, e?.item_id)
            setFieldValue(`rows.${index}.name`, e?.item_name)
            setFieldValue(`rows.${index}.code`, e?.code)
            setFieldValue(`rows.${index}.description`, e?.description)
            setFieldValue(`rows.${index}.inventoryBatchId`, e?.inventoryBatchId)
            setFieldValue(`rows.${index}.qty`, e?.qty)
            setFieldValue(`rows.${index}.uomId`, e?.uom_id)
            setFieldValue(`rows.${index}.uomName`, e?.uom_name)
            setFieldValue(`rows.${index}.price`, e?.uom_price)

            if (appendInventoryBatch)
                appendInventoryBatch({ itemId: e?.item_id, selectedIndexNo: index })

        })

        setFieldValue(`memberUserId`, document?.user_id)
        setFieldValue(`memberDisplay`, document?.profile_name)
        setFieldValue(`retailOutletBranchId`, document?.retail_outlet_id)
        setFieldValue(`retailOutletBranchDisplay`, document?.retail_outlet_name)
        setFieldValue(`retailerUserId`, authData?.profile?.parentUserId)

        let depStates = getDependencyItem({
            targetType: dependencyTargetTypes.document,
            dependencyModule: document?.type.toLowerCase(),
            dependencyRef: dependencyRefs.document,
            targetId: document?.id,
            relation: dependencyRelations.reference,
        })

        setFieldValue(formikDependencyStateField, [depStates])

    }

    const getFormikDependencyStates = ({ values }) => {
        return {
            [`${formikDependencyStateField}`]: values[`${formikDependencyStateField}`]
        }
    }

    return {
        updateFormikState,
        getFormikDependencyStates
    }

}